import { render } from "./VcBlogAnalyticsPage.vue?vue&type=template&id=7d8d46e8"
import script from "./VcBlogAnalyticsPage.vue?vue&type=script&lang=js"
export * from "./VcBlogAnalyticsPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__